import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { radioInputStyles, checkboxInputStyles, generalInputStyles } from './component-styles/input';

import { animation, colors, extendedColors } from '../styles';

const propTypes = {
  icon: PropTypes.element,
  isSubmitType: PropTypes.bool,
  isFullWidth: PropTypes.bool
};

const Input = props => {
  const { icon, isSubmitType = false, isFullWidth = false, ...allProps } = props;
  const iconGroup = icon ? <InputIcon>{icon}</InputIcon> : null;
  const customRadio = props.type === 'radio' ? <CustomRadio /> : null;

  return (
    <>
      {isSubmitType ? (
        <SubmitInputWrapper type="submit" isFullWidth={isFullWidth} {...allProps} />
      ) : (
        <InputWrapper {...allProps} />
      )}
      {iconGroup}
      {customRadio}
    </>
  );
};

const InputWrapper = styled.input`
  ${({ type }) => {
    switch (type) {
      case 'radio':
        return radioInputStyles;
      case 'checkbox':
        return checkboxInputStyles;
      default:
        return generalInputStyles;
    }
  }}
`;

const SubmitInputWrapper = styled.input`
  margin: 0 auto;
  cursor: pointer;
  display: block;
  border: 0;
  padding: 16px 32px;
  background-color: ${colors.buttonDefault} !important;
  color: ${colors.pureWhite};
  font-size: 14px;
  font-family: 'Lato', sans-serif;
  line-height: 16.8px;
  text-decoration: none;
  text-transform: uppercase;
  font-weight: 900;
  width: ${({ isFullWidth }) => (isFullWidth ? '100%' : 'auto')};
  transition: background-color ${animation.general.durationAndTiming};
  height: 48px;

  &:focus,
  &:hover,
  &:active {
    outline: 0;
    background-color: ${colors.buttonHover} !important;
  }

  &:disabled {
    pointer-events: none;
    background-color: ${colors.gray3};
  }
`;

const InputIcon = styled.span`
  position: absolute;
  right: 16px;
  bottom: 12px;
  color: ${colors.gray1};
`;

const CustomRadio = styled.div`
  display: inline-block;
  vertical-align: middle;
  border: 1px solid #9b9b9b;
  border-radius: 100%;
  height: 20px;
  width: 20px;
  top: 0px;
  left: 0px;
  margin-right: 20px;
  z-index: 5;
  pointer-events: none;

  &::before {
    display: block;
    position: absolute;
    content: '';
    border-radius: 100%;
    height: 12px;
    width: 12px;
    top: 10px;
    left: 4px;
    margin: auto;
    transition: background 0.15s linear;
    -webkit-transition: background 0.15s linear;
  }

  input[type='radio']:checked ~ &::before {
    background-color: ${extendedColors.crederaRed.light};
  }
`;

Input.propTypes = propTypes;

export { Input };
